module.exports = __webpack_public_path__ + "img/histories.5406dc9e.png";